import PreviewQROrders from './PreviewQROrders';

export default PreviewQROrders;
